export default { inheritAttrs: false }
